import { useContext } from 'react'
import BusinessRulesContext from '../contexts/BusinessRulesContext'

export const useBusinessRulesContext = () => {
  const ctx = useContext(BusinessRulesContext)
  if (!ctx) {
    throw new Error('useBusinessRulesContext debe usarse dentro de BusinessRulesProvider')
  }
  return ctx
}

export default useBusinessRulesContext

